import { render, staticRenderFns } from "./AssigneeSelector.vue?vue&type=template&id=2b1fe47c&scoped=true"
import script from "./AssigneeSelector.vue?vue&type=script&lang=js"
export * from "./AssigneeSelector.vue?vue&type=script&lang=js"
import style0 from "./AssigneeSelector.vue?vue&type=style&index=0&id=2b1fe47c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1fe47c",
  null
  
)

export default component.exports